import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { DATAWELL } from '../../constants/visualizationTypes';
import { Order } from '../../field/order';
//@ts-expect-error Untyped import
import { TransformType } from '../../transforms/transformRecords';
export const Directions = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
const Direction = checked.symbol(Directions, 'Direction');
export const ValueFormattingOption = checked.record({
  column: checked.string(),
  options: checked.map()
});
export const Formatting = checked.map(ValueFormattingOption);
export const ValueFormattingOptions = checked.list(ValueFormattingOption);

/**
 * @deprecated - use FieldOption from reporting-data/.../tsTypes/reportConfigTypes.ts instead
 */

export const FieldOption = checked.record({
  field: checked.string(),
  dataset: checked.string().optional(),
  subtitleField: checked.map().optional()
});
export const DatawellLayer = checked.record({
  name: checked.string().optional(),
  dataset: checked.string(),
  direction: Direction,
  order: Order.optional(),
  compact: checked.boolean().optional(),
  group: checked.string().optional(),
  // Only used if vertical for determining cell label
  fields: checked.list(checked.string()),
  // single field if vertical, one or more fields if horizontal
  fieldOptions: checked.list(FieldOption).optional(),
  compare: checked.string().optional(),
  // key of layer to provide compare against
  groupFormattingOptions: checked.any().optional(),
  // Keeping this value untyped fully in SF and passing in two different type of values.
  valueFormattingOptions: ValueFormattingOptions.optional(),
  transform: checked.list(TransformType).optional(),
  subtitleColumnMap: checked.map().optional(),
  abbreviateNumbers: checked.boolean().optional()
}, 'DatawellLayer');
export const Events = checked.record({
  getOnPointClick: checked.func().optional(),
  getHeader: checked.func().optional(),
  getBody: checked.func().optional()
}, 'Events');
export const DatawellVisualization = checked.record({
  type: checked.string().always(DATAWELL),
  data: checked.map(Dataset),
  layer: DatawellLayer,
  events: Events.optional()
}, 'DatawellVisualization');
export const DatawellCell = checked.record({
  label: checked.string(),
  value: checked.number(),
  valueLabel: checked.string(),
  tooltip: checked.string().optional(),
  row: checked.map(),
  compare: checked.number().optional(),
  compareValueLabel: checked.string().optional(),
  field: checked.string(),
  dataset: checked.string(),
  property: checked.string(),
  layer: DatawellLayer.optional(),
  inverseDeltas: checked.boolean(),
  summary: checked.map(),
  subtitleLabel: checked.string().optional(),
  subtitleValue: checked.number().optional(),
  subtitleValueLabel: checked.string().optional()
}, 'DatawellCell');
export const DatawellData = checked.record({
  data: checked.list(DatawellCell),
  events: Events.optional()
}, 'DatawellData');